import React, { useState } from "react";
import LensIllustration from "./lensillustration";


export const gridCols = (n) => (n <= 4 ? Math.max(n, 1) : n <= 6 ? 3 : 4);

/* "2/06" -> { current: 2, total: 6 } */
const parseStep = (label) => {
  const m = /^(\d+)\s*\/\s*(\d+)$/.exec(label || "");
  return m ? { current: Number(m[1]), total: Number(m[2]) } : null;
};

/* Picks the best image source for an option.
   imageSrc = local asset path (e.g. "/assets/images/quick-quiz/lens-bifocal.png")
   image    = path coming from your API */
export const resolveImage = (d) => {
  if (d?.imageSrc) return process.env.PUBLIC_URL + d.imageSrc;
  if (d?.image) return process.env.REACT_APP_IMAGE_URL + d.image;
  return null;
};

export const QuizHeader = ({ title, subtitle, stepLabel, onBack }) => {
  const step = parseStep(stepLabel);

  return (
    <header className="qz-header">
      <div className="qz-topbar">
        {onBack ? (
          <button className="qz-back" type="button" onClick={onBack} aria-label="Go back">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M15 5l-7 7 7 7" />
            </svg>
            <span className="qz-back__label">Back</span>
          </button>
        ) : (
          <span />
        )}

        {step ? (
          <div className="qz-progress" role="progressbar" aria-valuemin={1} aria-valuemax={step.total} aria-valuenow={step.current}>
            <div className="qz-lenses">
              {Array.from({ length: step.total }).map((_, i) => (
                <span
                  key={i}
                  className={`qz-lens ${i + 1 < step.current ? "is-done" : ""} ${i + 1 === step.current ? "is-current" : ""}`}
                />
              ))}
            </div>
            <p className="qz-progress__text">Question {step.current} of {step.total}</p>
          </div>
        ) : (
          <span />
        )}

        <span />
      </div>

      <h2 className="qz-title">{title}</h2>
      {subtitle && <p className="qz-subtitle">{subtitle}</p>}
    </header>
  );
};

const GlassesIcon = () => (
  <svg className="qz-fallback" viewBox="0 0 64 32" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
    <rect x="3" y="7" width="22" height="17" rx="8" />
    <rect x="39" y="7" width="22" height="17" rx="8" />
    <path d="M25 14c4-3 10-3 14 0" />
  </svg>
);

/* The lens-shaped picture window at the top of every image card.
    */
export const CardMedia = ({ src, alt, illustration, swatch }) => {
  const [failed, setFailed] = useState(false);
  const hasPhoto = src && !failed;

  let content;
  if (hasPhoto) {
    content = <img src={src} alt={alt || ""} loading="lazy" onError={() => setFailed(true)} />;
  } else if (illustration) {
    content = <LensIllustration type={illustration} />;
  } else if (swatch) {
    content = <span className="qz-swatch" style={{ background: swatch }} />;
  } else {
    content = <GlassesIcon />;
  }

  return (
    <div className={`qz-card__media ${!hasPhoto && illustration ? "qz-card__media--art" : ""}`}>
      {content}
    </div>
  );
};